import React,{useEffect,useState} from 'react';
import logo from './logo.svg';
import './App.css';
import axios from 'axios';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Welcome from './pages/welcome';
import { BookingForm } from './pages/bookinForm';



function App() {
   return (
    <Router>
      <Routes>
        <Route path="/" element={<Welcome />} />
        {/* <Route path="/login" element={<Login />} /> */}
      </Routes>
    </Router>
  );

}

export default App;
